/**
 * Erros específicos de `/physical-clients`. Os demais (400 com `errors[]`, 404, mensagens de toast) seguem
 * `customerRegistrationError.ts`. Nenhuma mensagem da API traz o CPF.
 */

export const CPF_ALREADY_REGISTERED_CODE = "cpf_already_registered";
export const ERP_CODE_ALREADY_REGISTERED_CODE = "erp_code_already_registered";

export const CPF_ALREADY_REGISTERED_MESSAGE = "CPF já cadastrado.";
export const CPF_FORBIDDEN_MESSAGE = "Você não tem permissão para ver o CPF completo.";

export interface PhysicalClientConflict {
  code: string;
  message: string;
  /** Cadastro existente (CPF duplicado), para o link "ver cadastro". */
  physicalClientId?: number;
}

interface ConflictResponse {
  response?: {
    status?: number;
    data?: { code?: unknown; message?: unknown; physicalClientId?: unknown };
  };
}

/** 409 de cadastro duplicado (CPF ou código ERP); null para qualquer outro erro. */
export function getPhysicalClientConflict(error: unknown): PhysicalClientConflict | null {
  const response = (error as ConflictResponse)?.response;
  if (response?.status !== 409 || typeof response.data?.code !== "string") return null;
  const { code, message, physicalClientId } = response.data;
  return {
    code,
    message: typeof message === "string" ? message : CPF_ALREADY_REGISTERED_MESSAGE,
    physicalClientId: typeof physicalClientId === "number" ? physicalClientId : undefined,
  };
}

export const isForbidden = (error: unknown): boolean => (error as ConflictResponse)?.response?.status === 403;
